<template>
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
    <path
      stroke-linecap="round"
      stroke-linejoin="round"
      d="M12 3v2.25m6.364.386l-1.591 1.591M21 12a9 9 0 11-18 0 9 9 0 0118 0m-9-3.75v.75m-4.364.386l-1.591-1.591M5.25 12a.75.75 0 11-1.5 0 .75.75 0 011.5 0z"
    />
  </svg>
</template>
